import React from 'react';
import Button from '../../../components/ui/Button';


const AuthFooter = ({ isLoading }) => {
  const handleCreateAccount = () => {
    window.location.href = '/register';
  };

  const handleForgotPassword = () => {
    // In a real app, this would open a forgot password modal or navigate to reset page
    console.log('Forgot password clicked');
  };

  return (
    <div className="space-y-6">
      {/* Divider */}
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border"></div>
        </div>
        <div className="relative flex justify-center text-xs uppercase">
          <span className="bg-surface px-2 text-text-secondary">Or</span>
        </div>
      </div>

      {/* Action Links */}
      <div className="space-y-4">
        <Button
          variant="outline"
          size="lg"
          onClick={handleCreateAccount}
          disabled={isLoading}
          fullWidth
          iconName="UserPlus"
          iconPosition="left"
        >
          Create New Account
        </Button>

        <div className="text-center">
          <button
            onClick={handleForgotPassword}
            disabled={isLoading}
            className="text-sm text-primary hover:text-primary/80 transition-smooth font-medium disabled:opacity-50"
          >
            Forgot your password?
          </button>
        </div>
      </div>

      {/* Help Text */}
      <div className="text-center pt-4 border-t border-border">
        <p className="text-xs text-text-secondary">
          Need help? Contact our support team for assistance with your account.
        </p>
      </div>
    </div>
  );
};

export default AuthFooter;